
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind13 as ObiWind13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-13.js';
 
 
 

 
 export const ObiWind13 = createComponent({
   react: React,
   tagName: 'obi-wind-13',
   elementClass: ObiWind13Element,
   events: {
     
   }
  });
 
 